// extracted by mini-css-extract-plugin
module.exports =  {"content":"_32bbee5fda--content--lwL1F"};